import styled from 'styled-components';

const BaseText = styled.div`
  margin-top: 16px;
  text-align: center;
  font-size: 10px;
  line-height: 18px;
  color: #707070;

  .highlight {
    font-weight: 500;
  }

  a {
    color: #707070;
    text-decoration: none;
  }
`;

export const SupportText = () => {
  return (
    <BaseText>
      <span className="highlight">Dúvidas?</span> Entre em contato com:<br/>
      <a href="mailto:faleconosco@zonasul.com.br" rel="noreferrer" target="_blank">faleconosco@zonasul.com.br</a>
    </BaseText>
  )
};
